import React from 'react';
import { BlockContainer } from './styled';

interface IProps {
  finalGrade?: string;
  credits?: string;
}
const ConvalidatedBlock = (props: IProps) => {
  const { finalGrade, credits } = props;

  return (
    <BlockContainer>
      <div className="convalidatedBlock">
        <p>
          Nota final: {finalGrade ? <span>{finalGrade}</span> : <span>C</span>}
        </p>
        <p style={{ marginBottom: '0px' }}>
          Créditos:{' '}
          {credits ? <span>{parseInt(credits, 10)}</span> : <span>--</span>}
        </p>
      </div>
    </BlockContainer>
  );
};

export default ConvalidatedBlock;
